import React from 'react'

import Layout from 'components/Layout'
import SEO from 'components/SEO'
import styled from 'util/style'

const Positives = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
`

const Positive = styled.div`
    flex: 1;
    padding-right: 20px;
    align-self: flex-start;
    max-width: 33%;
    flex: 1 0 33%;

    img {
        width: 100%;
    }
`

const PositiveImage = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;
`

export function PositivesPage({ data }) {

  return (
    <Layout>
      <SEO title="Daily Positives" />
        <h2>Daily Positives</h2>

        <Positives>
            {data &&
                data.allPrismicDailyPositive &&
                data.allPrismicDailyPositive.edges.map(edge => (
                    <Positive>
                        {edge.node.data.gutys_positive.localFile &&
                            <PositiveImage src={edge.node.data.gutys_positive.localFile.url} alt="Daily positive" />
                        }
                    </Positive>
                ))}
        </Positives>
    </Layout>
  )
}

export const query = graphql`
    query positives {
        allPrismicDailyPositive(sort: { fields: first_publication_date, order: DESC }) {
            edges {
                node {
                    id,
                    data {
                        gutys_positive {
                            localFile {
                                url
                            }
                        }
                    }
                }
            }
        }
    }
`

export default PositivesPage
